import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import { getCookie } from "@/util/cookies";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

// navigation guard
router.beforeEach((to, from, next) => {
  // check if route is restricted by role
  const token = getCookie("token");
  if (to.meta.requireAuth) {
    if (!token) {
      next({ name: "Login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
